/**
 * Class TfsManager
 * This util provides a properly formatted smpte timecode for the heartbeat to use in tfs polling.
 * It also can optionally run an interval to advance the given timecode to simulate a live game
 *
 * The primary usage is that this is that if TFS is active, this is the keeper of the current time
 * and the data load classescall getCurrentTimecode() to know what to append to the data query
 */
define(function (require, exports, module) {
/* eslint camelcase: "off" */
    var exists = require('extant/extant');
    var Moment = require('moment/moment');
    var logg = require('../utils/core-log');

    var syncActive = false; // running or no
    var timeMarchesOn = false; // advance? if false, the time stays constant,
    var r_verifyTfs = /\d{8,}_\d{6,}/;
    var fmtString = 'YYYYMMDD_HHmmss';
    var EMPTYSTRING = '';
    var m_dateTime;
    var m_prev_dateTime;
    var ticktock;
    var UNDEFINED = undefined;

    /**
     * Funciton init
     * @param $startTimecode {String} what point to start from
     * @param FFWD {int} if we care to change the poll frequency
     * @param startFires {Boolean} advance the time or no (usually yes)
     *
     * starts the tfs clock
     */
    exports.init = function ($startTimecode, startFires) {
        if (exists($startTimecode)) {
            if (setTimecode($startTimecode)) {
                timeMarchesOn = startFires === true;
                // begin the creation of the 'current' time code.
                beginSync();
            }
        }

        // else we got nothing to work with
    };

    /**
     * Function setTimecode
     * @param $timecode {String}
     *
     * @return {boolean} True signifies a valid timecode has been passed.  False, invalid.
     * does the heavy lifting in getting most formed or malformed time values to smpteTimecode
     */
    function setTimecode ($timecode, reset) {
        if (!exists($timecode) || !r_verifyTfs.test($timecode)) {
            // if we got no value, you're stupid and i won't help you
            logg.warn('invalid timecode requested', $timecode);
            stopSync();
            return false;
        }

        m_dateTime = Moment($timecode, fmtString);

        if (reset !== true) {
            m_prev_dateTime = m_dateTime;
        } else {
            m_prev_dateTime = null;
        }
        return true;
    }

    exports.setTimecode = setTimecode;


    /**
     * Function resetTimecode
     *
     * @return {boolean} True signifies a valid timecode has been passed.  False, invalid.
     * Resets internal tfs state
     */
    function resetTimecode() {
        m_dateTime = null;
        m_prev_dateTime = m_dateTime;
        return true;
    }

    exports.resetTimecode = resetTimecode;

    function incrementTimecode () {
        if (syncActive && ticktock && timeMarchesOn) {
            var newTc = Date.now();
            var diff = (newTc - ticktock) / 1000;
            var new_dateTime = new_dateTime = m_dateTime.clone().add(diff, 's');
            // console.warn("tiiiiiiiime  :: %o   to   %o", m_dateTime.format(fmtString), new_dateTime.format(fmtString))
            // parse out the new string
            setTimecode(new_dateTime.format(fmtString));
            ticktock = newTc;
        }
    }

    /**
     * Function beginSync
     * @param skipImmediateCall {Boolean}
     *
     * start the timecode advancing
     */
    function beginSync () {
        ticktock = Date.now();
        syncActive = true; // label the class as 'active'
    }

    exports.beginSync = beginSync;

    /**
     * Function stopySync
     *
     * stopsthe TFS advance interval, if one exists.
     */
    function stopSync () {
        logg.log('tfs :: shut\'er down');
        syncActive = false;
    }

    exports.stopSync = stopSync;

    /**
     * Function getCurrentTimecode
     * @param {boolean} diffPatch           Indicate whether diffpatch is active
     * @param {string}  previousTimecode    Last known active timecode (api response)
     * @returns {String}
     *
     * getter for the current time value, or live if no tfs TfsManager is active
     */
    exports.getCurrentTimecode = function (diffPatch, previousTimecode) {
        var tcString = EMPTYSTRING;
        var startTime;
        var endTime;

        if (!syncActive) {
            if (diffPatch === true && exists(previousTimecode)) {
                startTime = previousTimecode;
                tcString = '&startTimecode=' + previousTimecode;
            }
        } else {
            // bump it up to current
            incrementTimecode();
            endTime = this.getRawTimecode(m_dateTime);
            if (diffPatch !== true) {
                tcString = '&timecode=' + endTime;
            } else {
                startTime = exists(previousTimecode) ? previousTimecode : getRawTimecode(m_prev_dateTime);
                tcString = '&startTimecode=' + startTime + '&endTimecode=' + endTime;
            }
        };

        return {
            startTimecode: startTime,
            endTimecode: endTime,
            params: tcString
        };
    };

    exports.getRawPreviousTimecode = function () {
        return getRawTimecode(m_prev_dateTime);
    };

    exports.getRawCurrentTimecode = function () {
        return getRawTimecode(m_dateTime);
    };

    function getRawTimecode (m_timecode) {
        if (m_timecode) {
            return m_timecode.format(fmtString);
        }
        return '';
    };

    exports.getRawTimecode = getRawTimecode;

    /**
     * Function syncActive
     * @returns {boolean}
     *
     * returns true if clock is running
     */
    exports.syncActive = function () {
        return syncActive;
    };

    /**
     * Function setTimerAdvanceOption
     * @param $start
     *
     * stop or start the clock from advancing without effecting the tfs connection as-is
     */
    exports.setTimerAdvanceOption = function ($start) {
        timeMarchesOn = !!$start;
    };

    function compareTimecodes (previous, current) {
        if (!previous) {
            return true;
        }
        var prev = Moment(previous, fmtString);
        var cur = Moment(current, fmtString);

        return prev.isBefore(cur);
    }

    exports.compareTimecodes = compareTimecodes;

    exports.ensureTimecodeRangeIsValid = function (startTimecode) {
        if (m_dateTime && startTimecode) {
            return m_dateTime.isAfter(Moment(startTimecode, fmtString));
        }
        return !!startTimecode;
    };
});
